module.exports = __webpack_public_path__ + "icoInfProd1.png";